var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageCardContent',{class:( _obj = {}, _obj[_vm.$style.wrapper] = true, _obj[_vm.$style.imagePullLeft] = _vm.shouldPlaceImageOnTheLeftSide, _obj[_vm.$style.imagePullRight] = !_vm.shouldPlaceImageOnTheLeftSide, _obj ),attrs:{"image":_vm.image,"content":_vm.content,"content-class":_vm.contentClass,"image-class":_vm.imageClass}})}
var staticRenderFns = []

export { render, staticRenderFns }